module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 531.34 560.469",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }